module.exports = __webpack_public_path__ + "static/img/img-abstract-right.1e89cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-abstract-right.png
// module id = dOuO
// module chunks = 36